module.exports = __webpack_public_path__ + "assets/expedia-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/expedia-logo.png
// module id = 1212
// module chunks = 7